import { createAction } from "redux-actions";

const PREFIX = "CHANGE_APPROVERS";

export const add_row_change_approvers = createAction(`${PREFIX}/ADD_ROW`);
export const add_row_change_approvers_idle = createAction(`${PREFIX}/ADD_ROW_IDLE`);
export const add_row_change_approvers_success = createAction(`${PREFIX}/ADD_ROW_SUCCESS`);
export const add_row_change_approvers_failure = createAction(`${PREFIX}/ADD_ROW_FAILURE`);

export const remove_row_change_approvers = createAction(`${PREFIX}/REMOVE_ROW`);
export const remove_row_change_approvers_idle = createAction(`${PREFIX}/REMOVE_ROW_IDLE`);
export const remove_row_change_approvers_success = createAction(`${PREFIX}/REMOVE_ROW_SUCCESS`);
export const remove_row_change_approvers_failure = createAction(`${PREFIX}/REMOVE_ROW_FAILURE`);

export const update_row_change_approvers = createAction(`${PREFIX}/UPDATE_ROW`);
export const update_row_change_approvers_idle = createAction(`${PREFIX}/UPDATE_ROW_IDLE`);
export const update_row_change_approvers_success = createAction(`${PREFIX}/UPDATE_ROW_SUCCESS`);
export const update_row_change_approvers_failure = createAction(`${PREFIX}/UPDATE_ROW_FAILURE`);

export const get_approvers_documents_by_approvers = createAction(`${PREFIX}/GET_APPROVERS_DOCUMENTS_BY_APPROVERS`);
export const get_approvers_documents_by_approvers_idle = createAction(`${PREFIX}/GET_APPROVERS_DOCUMENTS_BY_APPROVERS_IDLE`);
export const get_approvers_documents_by_approvers_success = createAction(`${PREFIX}/GET_APPROVERS_DOCUMENTS_BY_APPROVERS_SUCCESS`);
export const get_approvers_documents_by_approvers_failure = createAction(`${PREFIX}/GET_APPROVERS_DOCUMENTS_BY_APPROVERS_FAILURE`);

export const update_approvers_documents_by_approvers = createAction(`${PREFIX}/UPDATE_APPROVERS_DOCUMENTS_BY_APPROVERS`);
export const update_approvers_documents_by_approvers_idle = createAction(`${PREFIX}/UPDATE_APPROVERS_DOCUMENTS_BY_APPROVERS_IDLE`);
export const update_approvers_documents_by_approvers_success = createAction(`${PREFIX}/UPDATE_APPROVERS_DOCUMENTS_BY_APPROVERS_SUCCESS`);
export const update_approvers_documents_by_approvers_failure = createAction(`${PREFIX}/UPDATE_APPROVERS_DOCUMENTS_BY_APPROVERS_FAILURE`);